import Script from 'next/script'

export const BlockthroughScripts = () => {
  return <Script src="https://btloader.com/tag?o=5668634355564544&upapi=true" />
}
